export default "__VITE_ASSET__BFVWWyN$__"